import React, { useCallback, useEffect, useState } from "react";
import { useCart } from "../../components/CartContext/CartContext";
import { useNavigate, useLocation } from "react-router-dom";
import CartSummary from "../../components/CartSummary/CartSummary";
import CartTable from "../../components/CartTable/CartTable";
import CartItemMobile from "../../components/CartItemMobile/CartItemMobile";
import Footer from "../../components/Footer/Footer";
import { useAuth } from "../../components/AuthContext/AuthContext";
import Header from "../../components/Header/Header";
import CartEmpty from "../../components/CartEmpty/CartEmpty";
import addressServiceInstance, { Address } from "../../APIs/address";
import { ProductContext } from "../../@types/productInfo";
const CartPage = () => {
  const {
    cart,
    removeFromCart,
  
    handleIncrease,
    handleDecrease,
    isUpdating,
    isDecreasing,
    itemStocks,

    fetchStockForAllItems,
    isRemoving,
  } = useCart();


  const [stockLoading, ] = useState<boolean>(true);

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);

    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, []);

  const handleRemoveItem = (product: ProductContext) => {

    try {
      removeFromCart(product);
    } catch (error) {
      console.error("Error removing item:", error);
    } finally {

    }
  };

  const [screenSize, setScreenSize] = useState(getCurrentDimension());


  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const [address, setAddress] = useState<Address | null>(null);



  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    };
    window.addEventListener("resize", updateDimension);
    return () => {
      window.removeEventListener("resize", updateDimension);
    };
  }, [screenSize]);

  const totalPrice = cart.reduce((total, item) => {
    const price = Number(item.original_price);

    return total + price * (item.item_quantity || 0);
  }, 0);

  const totalPriceIncludeVat = cart.reduce((total, item) => {
    const price = Number(item.price);

    return total + price * (item.item_quantity || 0);
  }, 0);

  const isEmpty = cart.length === 0;
  // if(cart.length > 0){
  //   fetchStockForAllItems()
  // }

  useEffect(() => {
    if (user?.email) {
      // setEmail(user.email);
    } else {
      localStorage.setItem("redirectAfterLogin", location.pathname);
    }
  }, [address, user, location.pathname]);

  const getUserAddress = useCallback(
    async (userId: number) => {
      try {
        const response = await addressServiceInstance.getAddressByUserId(
          userId
        );
       
        if (response.data) {
          setAddress(response.data || null);
         
        } else {
          console.error(response.error);
        }
      } catch (err) {
        console.error("Failed to fetch user address:", err);
        setAddress(null);
      }
    },
    [setAddress]
  );

  const createLogistics = async () => {
    navigate("/checkout");

    if (user) {
      navigate("/checkout");
    } else {
      navigate("/signup");
    }
  };

  useEffect(() => {
    if (user?.id && address === null) {
      getUserAddress(user.id);
    }
  }, [user?.id, getUserAddress, address]);

  return (
    <>
      <Header
        title="Your Cart"
        textBackground="YOUR CART"
        desktopHeight="100vh"
        backgroundImg={
          "http://res.cloudinary.com/brabenjos/image/upload/v1730187145/sodastream/1730187145422.png"
        }
        subTitle=""
      />
      {isEmpty ? (
        <CartEmpty />
      ) : (
        <section className="relative w-full mt-[-50%] md:mt-[-35%] lg:mt-[-30%]  mb-[20px]">
          <div className="md:relative gap-10  flex flex-col items-center justify-center w-full">
            <div className="text-[#005D6E] mt-[0px] mb-[25px]"></div>
            <div
              className="w-[95%] bg-white rounded-xl border border-gray-300 
            relative sm:w-[82%] 
          opacity-80 px-1 py-5 text-[#005D6E]">
              <div className="bg-white ">
                <div className="w-full">
                  <div className="hidden md:block">
                    <CartTable
                      cart={cart}
                      onIncrement={handleIncrease}
                      onDecrement={handleDecrease}
                      onRemove={handleRemoveItem}
                      itemStocks={itemStocks}
                      isUpdating={isUpdating}
                      isDecreasing={isDecreasing}
                      fetchStockForAllItems={fetchStockForAllItems}
                      isRemoving={isRemoving}
                      isMachine={false}
                      isBlack={false}
                      stockLoading={stockLoading}
                    />
                  </div>
                </div>
              </div>

              <div className="block md:hidden  ">
                <CartItemMobile
                  cart={cart}
                  onIncrement={handleIncrease}
                  onDecrement={handleDecrease}
                  onRemove={handleRemoveItem}
                  itemStocks={itemStocks}
                  isUpdating={isUpdating}
                  isDecreasing={isDecreasing}
                  isRemoving={isRemoving}
                  fetchStockForAllItems={fetchStockForAllItems}
                />
              </div>

              <div className=" -mx-5 -mb-10 p-5 z-9999">
                <CartSummary
                  totalPrice={totalPrice}
                  onCheckout={createLogistics}
                  loading={false}
                  totalPriceIncludeVat={totalPriceIncludeVat}
                />
              </div>
            </div>
          </div>
        </section>
      )}
      <Footer />
    </>
  );
};

export default CartPage;